import React, { useState } from 'react';
import { useSpeechSynthesis } from 'react-speech-kit';

function TexttoSpeech() {
  const [value, setValue] = useState('');
  const { speak } = useSpeechSynthesis();




  return (
    <div>
      <textarea
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
      <button onClick= {() => {
        var utterance = new window.SpeechSynthesisUtterance();
          utterance.text = "hello";
          utterance.lang = "en";
         window.speechSynthesis.speak(utterance);
      }

      }>Speak</button>
    </div>
  );
}

export default TexttoSpeech;